import React from 'react';
import '../styles/referral.css'; // Link to the CSS file

const ReferralPage = () => {
  return (
    <div className="referral-container">
      <div className="AHd">
        <div className='bn1'><img src="/img/referralpics.PNG" alt="" className='refImg'/></div>
        <div className='bn2'>
        <div className='Ad' >Adane Technology Referral Program</div>
        <p className='Ean'>Earn $3 worth of ADT Tokens when you refer someone who avails our services!</p>
        </div>
      </div>
      
      <div className="content">
        <div className="how-it-works">
          <div className="how-it-works1">How It Works</div>
          <ul className="how-it-works2">
            <li><div className='Yrn'>Refer someone who needs our software development or e-commerce services.</div></li>
            <li><div className='Yrn'>When they register and pay for any service, you’ll earn $3 worth of ADT tokens.</div></li>
            <li> <div className='Yrn'>Your ADT tokens will be redeemable after one month from the date of their registration.</div></li>
          </ul>
        </div>

        <section className="get-started ghgh">
      <h2 className="title" >Steps to Get Started</h2>
      {/* <div className='follow'>Follow this steps to get started</div> */}
      <div className='blur'></div>
      <div className="steps steps1">
        <div className="step" >
         
         <div className='bmLi' >
          <svg fill="#38e3cb" width="80px" height="80px" viewBox="0 0 256 256" id="Layer_1" version="1.1"  xmlns="http://www.w3.org/2000/svg" >

<g>

<path d="M184.4,48.5L184.4,48.5c1.9,9.7,10.4,16.8,20.3,16.8c9.9,0,18.4-7.1,20.3-16.8l2.5-12.7c0.8-6.2-1-12.4-5.1-17.1   s-10-7.4-16.2-7.4h-2.9c-6.2,0-12.1,2.7-16.2,7.4s-6,10.9-5.1,17.4L184.4,48.5z M194.6,25.3c2.2-2.5,5.4-4,8.8-4h2.9   c3.4,0,6.5,1.4,8.8,4c2.2,2.5,3.2,5.9,2.8,8.9l-2.4,12.4c-1,5.1-5.4,8.7-10.6,8.7s-9.6-3.7-10.6-8.7l-2.4-12.1   C191.4,31.2,192.4,27.8,194.6,25.3z"/>

<path d="M251.3,114.4l-5.7-27c-0.7-3.3-3.1-6-6.2-7.1l-19.7-7l-14.8,14.8l-14.8-14.8l-19.7,7c-3.1,1.1-5.5,3.8-6.2,7.1l-5.7,27   c-0.6,2.7,1.1,5.3,3.8,5.9c2.7,0.6,5.3-1.1,5.9-3.8l5.6-26.8l13.8-4.9l17.4,17.4l17.4-17.4l13.6,4.7l5.7,27   c0.5,2.3,2.6,3.9,4.9,3.9c0.3,0,0.7,0,1-0.1C250.1,119.8,251.8,117.1,251.3,114.4z"/>

<path d="M30.9,48.5L30.9,48.5c1.9,9.7,10.4,16.8,20.3,16.8c9.9,0,18.4-7.1,20.3-16.8L74,35.8c0.8-6.2-1-12.4-5.1-17.1   s-10-7.4-16.2-7.4h-2.9c-6.2,0-12.1,2.7-16.2,7.4s-6,10.9-5.1,17.4L30.9,48.5z M41.1,25.3c2.2-2.5,5.4-4,8.8-4h2.9   c3.4,0,6.5,1.4,8.8,4c2.2,2.5,3.2,5.9,2.8,8.9l-2.4,12.4c-1,5.1-5.4,8.7-10.6,8.7s-9.6-3.7-10.6-8.7l-2.4-12.1   C37.8,31.2,38.9,27.8,41.1,25.3z"/>

<path d="M68.7,84.8l13.6,4.7l5.7,27c0.5,2.3,2.6,3.9,4.9,3.9c0.3,0,0.7,0,1-0.1c2.7-0.6,4.4-3.2,3.8-5.9l-5.7-27   c-0.7-3.3-3.1-6-6.2-7.1l-19.7-7L51.2,88.2L36.4,73.3l-19.7,7c-3.1,1.1-5.5,3.8-6.2,7.1l-5.7,27c-0.6,2.7,1.1,5.3,3.8,5.9   c2.7,0.6,5.3-1.1,5.9-3.8L20,89.7l13.8-4.9l17.4,17.4L68.7,84.8z"/>

<path d="M128,189.5c9.9,0,18.4-7.1,20.3-16.8l2.5-12.7c0.8-6.2-1-12.4-5.1-17.1c-4.1-4.7-10-7.4-16.2-7.4h-2.9   c-6.2,0-12.1,2.7-16.2,7.4c-4.1,4.7-6,10.9-5.1,17.4l2.4,12.4v0C109.6,182.4,118.1,189.5,128,189.5z M117.8,149.5   c2.2-2.5,5.4-4,8.8-4h2.9c3.4,0,6.5,1.4,8.8,4c2.2,2.5,3.2,5.9,2.8,8.9l-2.4,12.4c-1,5.1-5.4,8.7-10.6,8.7s-9.6-3.7-10.6-8.7   l-2.4-12.1C114.6,155.4,115.6,152,117.8,149.5z"/>

<path d="M168.8,211.7c-0.7-3.3-3.1-6-6.2-7.1l-19.7-7L128,212.4l-14.8-14.8l-19.7,7c-3.1,1.1-5.5,3.8-6.2,7.1l-5.7,27   c-0.6,2.7,1.1,5.3,3.8,5.9c2.7,0.6,5.3-1.1,5.9-3.8l5.5-26.8l13.8-4.9l17.4,17.4l17.4-17.4l13.6,4.7l5.7,27   c0.5,2.3,2.6,3.9,4.9,3.9c0.3,0,0.7,0,1-0.1c2.7-0.6,4.4-3.2,3.8-5.9L168.8,211.7z"/>

<path d="M213.4,133.5c-2.8-0.3-5.2,1.7-5.4,4.5c-2,20.7-11.9,39.5-27.7,53c-2.1,1.8-2.3,4.9-0.6,7c1,1.2,2.4,1.7,3.8,1.7   c1.1,0,2.3-0.4,3.2-1.2c17.8-15.2,28.9-36.3,31.2-59.6C218.1,136.2,216.1,133.8,213.4,133.5z"/>

<path d="M48.1,138c-0.3-2.7-2.7-4.7-5.4-4.5c-2.7,0.3-4.7,2.7-4.5,5.4c2.3,23.3,13.4,44.5,31.2,59.6c0.9,0.8,2.1,1.2,3.2,1.2   c1.4,0,2.8-0.6,3.8-1.8c1.8-2.1,1.5-5.2-0.6-7C60,177.5,50.1,158.7,48.1,138z"/>

<path d="M101.7,54.1c16.7-5.9,35.9-5.9,52.7,0c0.5,0.2,1.1,0.3,1.7,0.3c2,0,4-1.3,4.7-3.3c0.9-2.6-0.4-5.4-3-6.3   c-18.9-6.7-40.4-6.7-59.3,0c-2.6,0.9-3.9,3.8-3,6.3C96.2,53.7,99.1,55,101.7,54.1z"/>

</g>

</svg>
          {/* <svg className="svg-inline--fa fa-user-plus ggj" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" data-fa-i2svg=""><path fill="currentColor" d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"></path></svg> */}
          </div>
          <h3 className="step-title step-title1">Step 1</h3>
          <p className="step-description">Share your unique referral link with someone who needs our services.</p>
        </div>
        <div className="step" >
        
          <div className='bmLi'>
   

<svg fill="#38e3cb" width="80px" height="80px" viewBox="0 0 64 64" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><rect height="4" width="19" x="35" y="58"/><path d="M54,20.276a7.733,7.733,0,0,0-7.724-7.724h-.484a1,1,0,0,1-.943-.666A7.317,7.317,0,0,0,31.3,11.272a1,1,0,0,1-1.62.286,7.272,7.272,0,0,0-5.21-2.179,7.351,7.351,0,0,0-7.175,5.839.993.993,0,0,1-1.022.8L16,16a6,6,0,0,0,0,12H46.276A7.733,7.733,0,0,0,54,20.276ZM41,18V16a6.006,6.006,0,0,1,6,6H45A4,4,0,0,0,41,18Zm4,6h2v2H45Z"/><path d="M58,13a2,2,0,0,0-2,2V30a1,1,0,0,1-.341.752l-7.977,6.98-4.975,4.975-1.414-1.414,6.5-6.5a1.829,1.829,0,0,0-2.586-2.586l-8.036,8.036A3.974,3.974,0,0,0,36,43.071v7.117a3.99,3.99,0,0,0,.2,1.265L37.721,56H52V47.415a6,6,0,0,1,.89-3.144l6.517-10.59a4,4,0,0,0,.593-2.1V15A2,2,0,0,0,58,13Z"/><path d="M16.207,32.207a1.831,1.831,0,0,0,0,2.586l6.5,6.5-1.414,1.414-4.975-4.975-7.977-6.98A1,1,0,0,1,8,30V15a2,2,0,0,0-4,0V31.585a4,4,0,0,0,.593,2.1l6.517,10.59A6,6,0,0,1,12,47.415V56H26.279L27.8,51.453a3.99,3.99,0,0,0,.2-1.265V43.071a3.974,3.974,0,0,0-1.171-2.828l-8.036-8.036A1.831,1.831,0,0,0,16.207,32.207Z"/><rect height="4" width="19" x="10" y="58"/></svg>
            {/* <svg className="svg-inline--fa fa-wallet ggj" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="wallet" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"></path></svg> */}
            </div>
          <h3 className="step-title step-title1"> Step 2</h3>
          <p className="step-description"> Once they complete the registration and payment, you’ll get an email notification.</p>
        </div>
      
        <div className="step" >
      
        <div className='bmLi'>
          <svg width="80px" height="80px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <g id="quality-5" transform="translate(-2 -2)">
    <circle id="secondary" fill="#38e3cb" cx="7" cy="7" r="7" transform="translate(5 3)"/>
    <path id="primary" d="M10,10l1.33,1.5L14,8.5" fill="none" stroke="#167c6e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path id="primary-2" data-name="primary" d="M5.79,13.57,3,17.56l3.03.9L7.91,21l2.88-4.11" fill="#38e3cb" stroke="#167c6e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path id="primary-3" data-name="primary" d="M18.21,13.57,21,17.56l-3.03.9L16.09,21l-2.88-4.11" fill="#38e3cb" stroke="#167c6e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <circle id="primary-4" data-name="primary" cx="7" cy="7" r="7" transform="translate(5 3)" fill="none" stroke="#167c6e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </g>
</svg>
          {/* <svg className="svg-inline--fa fa-chart-line ggj" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chart-line" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"></path></svg> */}
          </div>
          <h3 className="step-title step-title1">Step 3</h3>
          <p className="step-description">Your ADT tokens will be credited to your account and can be redeemed after 30 days.</p>
        </div>
      </div>
    </section>
        
       

        <div className="adt-section">
          <h2>Why Choose ADT Tokens?</h2>
           <div className="AHd tAF">
       
        <div className='bn2'>
        
        <p className=''>ADT tokens are part of the AdaneTech ecosystem and can be used for payments, discounts on services, or traded on supported platforms. Join our growing community and start earning today!</p>
        </div>
         <div className='bn1'>
          <div className='N1b'>
            <ul className='N1b1'>
              <li className='N1b2'>campaign management</li>
              <li className='N1b2'>Salaries management</li>
              <li className='N1b2'>Program management</li>
              <li className='N1b2'>Studies payment</li>
            </ul>
          </div></div>
      </div>
          
        </div>

        <div className="cta-sectionR">
          <h2>Get Started Today!</h2>
          <p>Share your referral link, help others discover cutting-edge software solutions, and get rewarded!</p>
          <button className="cta-buttonR">Get Your Referral Link</button>
        </div>
      </div>
    </div>
  );
};

export default ReferralPage;
